<div [formGroup]="smsMessage" class="container">
  <div class="form-group driver-sms-message__opt-in-row">
    <div class="driver-sms-message__opt-in-col">
      <label class="form-label" i18n="@@S_PHONENUMBER">Phone Number</label>
      <p>{{ phoneNumber }}</p>
    </div>
    <div class="driver-sms-message__opt-in-col">
      <label class="form-label" i18n="@@S_SMS_OPTIN_STATUS">SMS Opt-In Status</label>
      <p>
        <strong class="text-danger" *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.Unknown" i18n="@@S_SMS_OPTIN_UNKNOWN"
          >Unknown</strong
        >
        <strong
          class="text-danger"
          *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.MaxInvitationsSent"
          i18n="@@S_SMS_MAX_REQUEST_WARNING"
          >The maximum number of requests have been sent. You may activate this device's SMS manually.</strong
        >
        <strong class="text-danger" *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.CanInvite" i18n="@@S_NOT_OPTED_IN"
          >Not Opted In</strong
        >
        <strong class="text-danger" *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.DoNotContact" i18n="@@S_SMS_OPTEDOUT"
          >Opted Out</strong
        >
        <strong class="text-success" *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.CanSendSms" i18n="@@S_OPTED_IN">Opted In</strong>
      </p>
      <div
        *ngIf="
          smsOptInStatus.OptInStatus === ESmsOptInStatus.CanInvite || smsOptInStatus.OptInStatus === ESmsOptInStatus.MaxInvitationsSent
        "
      >
        <small class="form-text text-muted">
          <span i18n="@@S_SMS_OPTIN_REQUEST_COUNT">Requests</span>: {{ smsOptInStatus.RequestsSent }}
          <span i18n="@@S_SMS_OPTIN_LAST_SENT">Last sent</span>: {{ smsOptInStatus.LastRequestSentDate }}
        </small>
      </div>

      <button
        mat-raised-button
        type="button"
        *ngIf="smsOptInStatus.OptInStatus === ESmsOptInStatus.CanInvite"
        i18n="@@S_SMS_SENDNEWREQUEST"
        class="driver-sms-message__opt-in-btn"
        componentStyle="secondary"
        [actionResult]="invitationResult"
        (click)="onSendInvitationClick()"
      >
        Send New Opt-In Request
      </button>
    </div>
  </div>

  <mat-form-field floatLabel="always" class="driver-message__content__form__field driver-message__content__form__field__textarea">
    <mat-label class="form-label" i18n="@@S_MESSAGE">Message</mat-label>
    <textarea
      matInput
      [attr.disabled]="smsOptInStatus.OptInStatus !== ESmsOptInStatus.CanSendSms ? '' : null"
      placeholder="Enter your message"
      i18n-placeholder="@@S_MESSAGE_PLACEHOLDER"
      rows="3"
      maxlength="80"
      formControlName="message"
    ></textarea>
    <mat-error *ngIf="message.invalid && isFormSubmitted" i18n="@@S_NO_MESSAGE_SPECIFIED">No message specified</mat-error>
  </mat-form-field>

  <small class="form-text">
    <span i18n="@@S_SEND_MESSAGE_MAXCHARACTERS">Maximum characters:</span>
    <strong>80</strong>
    <span i18n="@@S_SEND_MESSAGE_TOTALCHARS" class="driver-sms-message__info-total">Total:</span>
    <strong>{{ message.value ? message.value.length : 0 }}</strong>
  </small>
  <small class="form-text text-muted" i18n="@@S_SEND_MESSAGE_PHONEDESC"
    >Standard text messages rates apply for recipients of text messages.</small
  >
</div>
